var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 12,
    x: 5,
    y: 6,
    fill: "#2F68D1",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 12,
    x: 5,
    y: 21,
    fill: "#FFD2A8",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 12,
    x: 5,
    y: 36,
    fill: "#B4CFFF",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 12,
    x: 24,
    y: 36,
    fill: "#6C9BF1",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 12,
    x: 5,
    y: 51,
    fill: "#FF9D43",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 12,
    x: 40,
    y: 51,
    fill: "#2F68D1",
    rx: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.275,
    cy: 18.274,
    r: 10.801,
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    transform: "rotate(-45 47.275 18.274)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m54.912 25.912 11.456 11.456"
  })));
};
export default SvgSearch;